import { useEffect, useEffectEvent } from 'react'
import { useSelector } from '@/libs/state'
import { listWorkItems } from '../application/list-work-items'
import type { WorkItemFilter } from '../domain/workflow'
import { workItems$ } from '../store'
import { workItems as workItemsPort, notify } from '../wiring'

const useWorkItems = (companyWorkflowId: string, teamId: string | null = null, filter?: WorkItemFilter) => {
	const workItems = useSelector(workItems$)

	const reload = useEffectEvent(async () => {
		const result = await listWorkItems(workItemsPort, companyWorkflowId, teamId, notify, filter)
		workItems$.set(result)
	})

	// Refetch on mount and whenever the identifying inputs change. The filter object's
	// identity is collapsed to a primitive key so callers need not memoize it.
	const filterKey = filter ? JSON.stringify(filter) : ''
	useEffect(() => {
		reload()
	}, [companyWorkflowId, teamId, filterKey])

	return { workItems, reload }
}

export { useWorkItems }
